import Cookies from 'js-cookie';
const TokenKey = 'Admin-Token';
const UserInfoKey = 'User-Info';

//存储token
export function getToken() {
    return Cookies.get(TokenKey);
}

export function setToken(token) {
    return Cookies.set(TokenKey, token);
}

export function removeToken() {
    return Cookies.remove(TokenKey);
}

//存储用户信息
export function getUserInfo() {
    return localStorage.getItem(UserInfoKey) ? JSON.parse(localStorage.getItem(UserInfoKey)) : null
}

export function setUserInfo(info) {
    return localStorage.setItem(UserInfoKey, JSON.stringify(info));
}

export function removeUserInfo() {
    return localStorage.removeItem(UserInfoKey);
}


